import { black_color } from "styles/theme";

export const fabricatorStreamlineDetailsContainerStyle = {
    backgroundColor: black_color
}

export const fabricatorStreamlineDetailsSpacerStyle = {
    height: "50px"
}